import { jsx as _jsx } from "react/jsx-runtime";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
export var DataList = function (_a) {
    var children = _a.children, _b = _a.gap, gap = _b === void 0 ? 2 : _b, _c = _a.showDivider, showDivider = _c === void 0 ? true : _c;
    return (_jsx(Stack, { direction: "column", gap: gap, divider: showDivider ? _jsx(Divider, { orientation: "horizontal" }) : false, children: children }));
};
